import React from 'react';

const SelectedPlantInfo = ({ selectedPlantData }) => {
	return (
		<div className='plant-info-container'>
			{selectedPlantData ? (
				<>
					<div className='plant-info-text-container'>
						<p>
							{selectedPlantData.Common}
							<br /><i>({selectedPlantData.Botanical})</i><br />
							Height: {selectedPlantData.Height} &nbsp;&nbsp;&nbsp; Width: {selectedPlantData.Width}
						</p>
					</div>
					<p>{selectedPlantData.Notes}</p>
				</>
			) : (
				<>
					<p>No plant currently selected</p>
				</>
			)}
		</div>
	);
};

export default SelectedPlantInfo;
